export default __webpack_public_path__ + "static/media/elk@3x.f61c2caa.jpg";